import {useSelector} from 'Provider';
import React from 'react';

import AEMHtml from 'components/AEM/AEMHtml';
import {empireFooterContentSelector} from 'store/content/content.selectors';

/** Displays the footer contents from AEM (https://www.caesars.com/footer) */
const ConnectedAEMFooter: React.FunctionComponent = () => {
  const empireFooterHtml = useSelector(empireFooterContentSelector);
  return <AEMHtml contents={empireFooterHtml} />;
};

export default ConnectedAEMFooter;
